import dataModel from '../../models/DataModel.js';
import locationsService from '../../services/locationsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const location_root = {
  location: {
    market: {
      
    },
    location_users: {
      user: { },
    },
    users: {},
  },
};

export const locations_nav_root = {
  location: {
  },
};

export const location_shallow = {
  location: {
    market: {},
    excludeFields: ['location_users', 'users', 'projects_count', 'builds_count'],
  },
};

export default class LocationsCollection extends AOCollection {
  constructor(name, perPage, searchString, userId, companyId, subKey, filter, recordDescriptor, marketId) {
    super({
      name: name,
      collectionType: ReduxConstants.LOCATION,
      perPage, 
      searchString, 
      userId,
      companyId, 
      subKey,
      filter,
      recordDescriptor,
    });
    this.marketId = marketId;
    this.processItemActionCable = this.processItemActionCable.bind(this);
  }

  static build(name, perPage, searchString, userId, companyId, subKey, filter, recordDescriptor, marketId) {
    if (name == null) {
      name = ReduxConstants.LOCATIONS;
    }
    const collection = new LocationsCollection(name, perPage, searchString, userId, companyId, subKey, filter, recordDescriptor, marketId);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor ? collectionData.recordDescriptor : recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchWithProjects(options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = locationsService.getLocationsWithProjects.bind(this, this._searchString, this._filter, options);
        let newCollection = await this._fetchData(serviceCall, options, true);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        newCollection.totalLocations = newCollection.totalRecords;
        return resolve(newCollection);
      });
    }
  }

  async fetchNext(pageOverride, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else this.page++;

        let serviceCall = locationsService.getLocations.bind(this, this._searchString, this.marketId, this.page, this.perPage, null, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        newCollection.totalLocations = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        let page = null;
        let perPage = null;
        
        // Get everything we already got
        if (shouldPaginate) {
          page = 1;
          if (collection && collection.perPage) {
            perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
    
        let serviceCall = locationsService.getLocations.bind(this, this._searchString, this.marketId, page, perPage, null, options);
        let newCollection = await this._fetchData(serviceCall, options);
    
        newCollection.totalLocations = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }

  async processItemActionCable(updatedLocation, acData, recordDescriptor) {
    if (updatedLocation) {
      let not_started_projects_count = updatedLocation.not_started_projects_count;
      let in_progress_projects_count = updatedLocation.in_progress_projects_count;
      let completed_projects_count = updatedLocation.completed_projects_count;
      if (this._filter && this._filter.statuses && this._filter.statuses.length > 0) {
        if (!this._filter.statuses.find(stat => { return stat == 'not_started'; })) {
          not_started_projects_count = 0;
        }
        if (!this._filter.statuses.find(stat => { return stat == 'in_progress'; })) {
          in_progress_projects_count = 0;
        }
        if (!this._filter.statuses.find(stat => { return stat == 'complete'; })) {
          completed_projects_count = 0;
        }
      }

      updatedLocation.not_started_projects_count = not_started_projects_count;
      updatedLocation.in_progress_projects_count = in_progress_projects_count;
      updatedLocation.completed_projects_count = completed_projects_count;
    }
    return new Promise((resolve) => {
      const locationsCollection = this.getDenormalizedCollection({ recordDescriptor });
      if (acData.type == 'newLocation' || acData.type == 'updateLocation' || acData.type == 'updatedLocation') {
        if (updatedLocation && ((this.marketId && this.marketId == updatedLocation.market_id) || !this.marketId)) {
            
          let found = false;
          locationsCollection.locations = locationsCollection.locations.map(loc => {
            if (loc.id == updatedLocation.id) {
              found = true;
              return updatedLocation;
            }
            else {
              return loc;
            }
          });
          if (!found) {
            locationsCollection.locations.push(updatedLocation);
            locationsCollection.totalLocations++;
          }
          locationsCollection.totalRecords = locationsCollection.totalLocations;
          locationsCollection.ids = this.normalizeCollection(locationsCollection.locations, { store: true });
          dataModel.collectionsDAO.setCollection(this.getKey(), locationsCollection, this.getCollectionType());
          return resolve(this.getDenormalizedCollection({ recordDescriptor }));
        }
      }
      else if (acData.type == 'deleteLocation') {
        let found = false;
        locationsCollection.locations = locationsCollection.locations.filter(loc => {
          if (loc.id != acData.location_id){
            return true;
          }
          else {
            found = true;
            return false;
          }
        });
        if (found) {
          locationsCollection.totalLocations--;
        }
        locationsCollection.totalRecords = locationsCollection.totalLocations;
        locationsCollection.ids = this.normalizeCollection(locationsCollection.locations, { store: true });
        dataModel.collectionsDAO.setCollection(this.getKey(), locationsCollection, this.getCollectionType());
        return resolve(this.getDenormalizedCollection({ recordDescriptor }));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/LocationsCollection.js